
@if(currentScreenSize === 'xSmall'){
    <app-login-mobile></app-login-mobile>
}@else{
    <app-header-simple/>
    <app-login-input></app-login-input>
    <app-footer class="d-block" [data]="" />
}